import { Injectable } from '@angular/core';

export interface AppConfig {
  apiUrl: string;
  apiUrlV2: string;
  eventsApiUrl: string;
  pageSize: number;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: AppConfig;

  constructor() {}

  loadConfig(config: AppConfig): void {
    this.config = config;
  }

  get apiUrl(): string {
    return this.config.apiUrl;
  }

  get apiUrlV2(): string {
    return this.config.apiUrlV2;
  }

  get eventsApiUrl(): string {
    return this.config.eventsApiUrl;
  }

  get pageSize(): number {
    return this.config.pageSize;
  }
}
